var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLtc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9217 25.7792C20.0215 25.7792 25.777 20.0236 25.777 12.9237C25.777 5.8239 20.0215 0.0683594 12.9217 0.0683594C5.82182 0.0683594 0.0662842 5.8239 0.0662842 12.9237C0.0662842 20.0236 5.82182 25.7792 12.9217 25.7792Z",
    fill: "#3D5E98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1704 16.358L13.0054 13.2139L14.9823 12.4916L15.474 10.6438L15.4572 10.598L13.5112 11.3089L14.9133 6.02954H10.937L9.10341 12.9192L7.5725 13.4785L7.06665 15.3834L8.59639 14.8246L7.51573 18.8851H18.0983L18.7767 16.358H12.1704Z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtc);
export default __webpack_public_path__ + "static/media/ltc.f0c733277c9f8f187d71dd92d38de68f.svg";
export { ForwardRef as ReactComponent };